// removed by extract-text-webpack-plugin
module.exports = {"root":"import_root_67lwnm","actions":"import_actions_8w6xrd","layout":"import_layout_1zoak8","column":"import_column_cmnwbr","combined":"import_combined_8pxjxz"};


//////////////////
// WEBPACK FOOTER
// ./packages/page-index/src/import/import.scss
// module id = 564
// module chunks = 0